import React from 'react';
import Link from 'gatsby-link';

import './index.css';

const Header = () => (
  <div className='header'>
    <div>
      <h1>
        <Link to="/" className='site-title'>
          alexk.io
        </Link>
      </h1>
    </div>
    <div className='menu-items'>
      <h1>
        <Link to="/tags/tech/" className='sub-topic'>Tech</Link></h1>
      <h1 className='left-pad'>
        <Link to="/tags/travel/" className='sub-topic'>Travel</Link>
      </h1>
      <h1 className='left-pad'>
        <Link to="/tags/gear/" className='sub-topic'>Gear</Link></h1>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js